/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {h} from 'preact';
import PropTypes from 'prop-types';
import styles from '../../styles/video-quality.css';
import config from '../../../config';

// Video quality translation taken from https://phenixrts.com/docs/api/#supported-quality-capabilities
const videoQualityMap = {
  uld: '144',
  vld: '240',
  ld: '350',
  sd: '480',
  hd: '720',
  fhd: '1080'
};
const VideoQualityButton = ({toggleVideoSettings, isQualityListShown, setVideoQuality, selectedVideoQuality}) => (
  <div className={styles.videoQualityButtonContainer}>
    <i
      id="videoQuality"
      onClick={toggleVideoSettings}
      title={'Settings'}
      className={styles.videoQualityButton}
    />
    {isQualityListShown && (
      <div className={styles.videoQualitySettings}>
        <div className={styles.videoQualityText}>Quality</div>
        {config.qualities.slice().reverse().map((quality) => (
          videoQualityMap[quality] ? (
            <div key={quality} className={selectedVideoQuality === quality ? styles.selectedVideoQuality : ''} onClick={() => setVideoQuality(quality)}>
              {videoQualityMap[quality]}p<span>{parseInt(videoQualityMap[quality]) >= 720 ? 'HD' : '' }</span>
            </div>
          ) : null
        ))}
      </div>
    )}
  </div>
);

VideoQualityButton.propTypes = {
  isQualityListShown: PropTypes.bool.isRequired,
  toggleVideoSettings: PropTypes.func.isRequired,
  setVideoQuality: PropTypes.func.isRequired,
  selectedVideoQuality: PropTypes.string.isRequired
};

export default VideoQualityButton;